module.exports = __webpack_public_path__ + "images/izibike_small58be483a4dd95894a4ab4f07481c54c8.png";